import React from 'react';

import { getBtnClass } from '@triage-help/helpers';

const Progression = ({ step, goToStep, goToPrev }) => {
  const prevLink = step.link.find(l => l.type == 'prev');

  return (
    <div className="fv-triage-card">
      <div className="row">
        <div
          className="col-md-12 fv-triage-card__content"
          dangerouslySetInnerHTML={{ __html: step.content }}
        />
        <div className="col-md-12 fv-triage-card__links">
          {prevLink && (
            <button
              className={getBtnClass(prevLink.type)}
              onClick={() => goToPrev()}
            >
              {prevLink.text}
            </button>
          )}
          <div className="fv-triage-card__links__next">
            {step.link
              .filter(l => l.type != 'prev')
              .map((link, i) => {
                return (
                  <button
                    className={getBtnClass(link.type)}
                    key={i}
                    onClick={() => goToStep(link.target)}
                  >
                    {link.text}
                  </button>
                );
              })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Progression;
